import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UserService {
    private user: any;

    isAdmin() {
        return this.user?.role === 'admin';
    }

    setUser(user: any) {
        this.user = user;
    }

    getUser(): Observable<any> {
        return this.user;
    }
}
